import { Link } from "react-router-dom"
import { Card, CardContent, CardFooter } from "./ui/card"
import { Badge } from "./ui/badge"
import { Calendar, ArrowRight } from "lucide-react"

export function BlogCard({ title, excerpt, date, category, image, href }) {
  return (
    <Card className="overflow-hidden transition-all hover:shadow-md hover:translate-y-[-5px] duration-300">
      <div className="relative w-full h-[18rem]">
        <img
          src={image || "/placeholder.svg"}
          alt={title}
          className="object-cover w-full h-full"
        />
       
      </div>
      <CardContent className="p-4">
        <div className="flex items-center justify-between mb-2">
          <Badge variant="outline" className="text-primary border-primary">
            {category}
          </Badge>
          <div className="flex items-center text-sm text-muted-foreground">
            <Calendar className="w-3 h-3 mr-1" />
            {date}
          </div>
        </div>
        <h3 className="mb-2 text-lg font-bold">{title}</h3>
        <p className="text-muted-foreground">{excerpt}</p>
      </CardContent>
      <CardFooter className="p-4 pt-0">
        <Link
          to={href}
          aria-label={`Read more about ${title.length > 50 ? title.substring(0, 50) + "..." : title}`}
          className="flex items-center text-primary hover:underline group"
        >
          Read More
          <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
        </Link>
      </CardFooter>
    </Card>
  )
}